



















import { Component, Vue, Prop } from "vue-property-decorator";
import { IndicatorCardData } from "@/types";
import BiCard from "@/components/BiCard";

@Component({
  components: {
    BiCard,
  },
})
export default class Funnel extends Vue {
  @Prop() title!: string;
  @Prop() description!: string;
  @Prop({ default: () => [] }) items!: Array<IndicatorCardData>;
  @Prop({ default: false }) twoCards!: boolean;
}
